const _excluded = ["href"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.symbol.description.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { createTheme } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import { mergeDeep } from "./helpers/helpers.js"; // function LinkBehaviour avoids having to do LinkBehavior.displayName = 'LinkBehavior';
import { jsx as _jsx } from "react/jsx-runtime";
const LinkBehavior = /*#__PURE__*/forwardRef(function LinkBehavior(props, ref) {
  const {
      href
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  // Map href (MUI) -> to (react-router)
  //If href starts with http or https, then it is an external link
  if (href.startsWith('http')) {
    return /*#__PURE__*/_jsx("a", _objectSpread({
      href: href,
      ref: ref
    }, other));
  }
  return /*#__PURE__*/_jsx(NavLink, _objectSpread({
    end: true,
    ref: ref,
    to: href
  }, other));
});
LinkBehavior.propTypes = {
  href: PropTypes.oneOfType([PropTypes.shape({
    hash: PropTypes.string,
    pathname: PropTypes.string,
    search: PropTypes.string
  }), PropTypes.string]).isRequired
};
const darkBlue = '#1F4765';
const lightBlue = '#2b5c92';
const lightGray = '#C8C8C8';
const orange = '#D16400';

// This is the base theme that is used to create the theme for the app
// It is recommended to create your own theme and then merge it with the base theme
const baseThemeProperties = {
  appBar: {
    logo: {
      height: '100%',
      width: 'auto',
      maxHeight: '44px',
      top: '3px',
      position: 'relative'
    }
  },
  pamGrid: {
    width: '100%',
    height: '100%',
    minHeight: '500px',
    minWidth: '700px',
    flexGrow: 1,
    '& .pam-grid-header': {
      // This is the header to the grid. We set the background color to match the theme from invision
      backgroundColor: lightBlue,
      color: 'white'
    },
    '& .MuiDataGrid-iconButtonContainer > .MuiButtonBase-root': {
      // Since the header is dark the icons need to be light
      color: 'white'
    },
    '& .MuiDataGrid-menuIcon > .MuiButtonBase-root': {
      // Since the header is dark the icons need to be light
      color: 'white'
    },
    '& .row-odd': {
      // Odd rows are slightly darker
      backgroundColor: '#e6ecf2'
    }
  },
  singleFlexRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    justifyContent: 'space-between'
  },
  actionLinkRow: {
    fontFamily: 'inherit',
    color: orange,
    fontSize: '12px',
    fontWeight: 'bold',
    display: 'inline-block',
    lineHeight: '1.75',
    marginRight: '10px',
    marginLeft: '5px'
  },
  cardContent: {
    fontSize: '12px',
    marginLeft: '5px',
    marginRight: '5px'
  },
  inspector: {
    icon: {
      color: orange,
      fontSize: '16px',
      marginRight: '3px'
    },
    noData: {
      color: lightGray,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '70vh'
    },
    heading: {
      fontFamily: 'sans-serif',
      fontSize: '22px',
      fontWeight: 'bold',
      color: darkBlue
    },
    clearButton: {
      fontSize: '12px',
      marginBottom: '5px'
    },
    cardHeader: {
      lineHeight: '1.5',
      marginRight: '10px',
      marginLeft: '5px',
      fontSize: '16px',
      fontWeight: '600'
    },
    cardFooter: {
      lineHeight: '1.75',
      marginRight: '10px',
      marginLeft: '5px'
    },
    cardFooterLinks: {
      color: orange,
      fontSize: '12px',
      fontWeight: 'bold',
      display: 'inline-block'
    },
    featuredCard: {
      heading: {
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
        fontSize: '14px',
        color: darkBlue,
        marginTop: '10px'
      },
      legend: {
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
        fontSize: '32px',
        color: '#434343',
        marginBottom: '20px'
      }
    }
  },
  filterableCard: {
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingBottom: '4px',
      borderBottom: "2px solid ".concat(lightGray)
    }
  },
  palette: {
    text: {
      header: darkBlue,
      special: '#FFDE58'
    },
    inspectorItem: {
      outer: {
        border: '1px solid black',
        borderRadius: '5px',
        marginBottom: '10px',
        marginTop: '15px'
      },
      inner: {
        padding: '0.5em'
      },
      divider: {
        backgroundColor: 'black'
      }
    },
    mapSidebar: {
      background: lightBlue,
      selectedBackground: '#002D4C',
      text: '#ffffff',
      selectedText: '#ffffff'
    },
    slider: {
      default: '#33CF4D',
      border: '6px solid #fff'
    },
    background: {
      default: '#B3B3B3'
    },
    hover: {
      dark: '#001F35'
    },
    primary: {
      maintwo: darkBlue,
      main: '#002D4C',
      light: '#027AC8',
      text: '#ffffff'
    },
    secondary: {
      main: orange,
      light: '#F68802',
      text: '#ffffff'
    },
    regressive: {
      main: orange,
      light: '#F68802',
      dark: '#683200',
      text: '#ffffff',
      contrastText: '#ffffff'
    },
    tertiary: {
      main: '#939743',
      text: '#44461F',
      light: '#c5c871',
      dark: '#636915',
      lightBlue: lightBlue
    },
    accent: {
      main: '#FFFFFF',
      contrastText: '#1F4765'
    },
    grayscale: {
      main: '#979797',
      light: '#D8D8D8',
      lighter: '#F1F1F1',
      lightest: lightGray
    },
    toggleBackground: {
      main: '#A5FF98'
    }
  },
  typography: {
    fontFamily: ['"PT Sans"', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    navLink: {
      fontFamily: 'inherit',
      fontSize: '0.875rem',
      fontWeight: 'bold',
      color: "".concat(orange, " !important"),
      textDecorationColor: "".concat(orange, " !important"),
      marginTop: 2,
      marginBottom: 2
    },
    subHeader: {
      fontSize: '0.875rem',
      fontWeight: 'bold',
      color: darkBlue,
      marginTop: 2,
      marginBottom: 2
    },
    inspector: {
      fontSize: '0.875rem',
      marginTop: '8px',
      marginBottom: '8px'
    },
    lineItem: {
      fontSize: '0.875rem',
      marginTop: '8px',
      marginBottom: '8px'
    },
    sectionHeader: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: darkBlue,
      marginTop: 2,
      marginBottom: 2
    },
    panelHeader: {
      fontSize: '1.25rem',
      fontWeight: 'bold',
      color: darkBlue,
      marginTop: 2,
      marginBottom: 2
    },
    modalTitle: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      color: darkBlue,
      marginTop: '20px',
      marginBottom: '0',
      textAlign: 'center'
    }
  },
  components: {
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          sectionHeader: 'h1',
          subHeader: 'h2',
          modalTitle: 'h2',
          panelHeader: 'h2',
          inspector: 'p',
          navLink: 'a'
        }
      }
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: '#434343'
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        h1: {
          fontSize: '16px',
          color: darkBlue
        }
      }
    },
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
        underline: 'hover'
      }
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior
      }
    },
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        color: 'primary'
      },
      variants: [{
        props: {
          variant: 'contained'
        },
        style: {
          borderRadius: 28
        }
      }, {
        props: {
          variant: 'user'
        },
        style: {
          borderRadius: 28
        }
      }, {
        props: {
          variant: 'panel'
        },
        style: {
          display: 'block',
          borderRadius: '0px',
          textTransform: 'none',
          marginRight: '0px !important',
          marginLeft: '0px !important',
          width: '100%',
          textAlign: 'left',
          color: darkBlue,
          '&.active': {
            background: '#EBEEF1',
            cursor: 'not-allowed'
          }
        }
      }, {
        props: {
          variant: 'dashed'
        },
        style: {
          textTransform: 'none',
          border: '2px dashed grey'
        }
      }, {
        props: {
          variant: 'appbar'
        },
        style: {
          color: 'white',
          borderRadius: '0px',
          background: 'none',
          '&.active': {
            borderBottom: '2px solid',
            borderColor: orange
          }
        }
      }]
    },
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: '#002D4C'
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '14px'
        }
      }
    }
  }
};

// Export a default MUI theme
// This is used by the MUI ThemeProvider in our storybook
const theTheme = createTheme(baseThemeProperties);

// Use deep merge to merge the base theme with any custom theme properties
const mergeThemeProperties = themeProperties => {
  return mergeDeep(baseThemeProperties, themeProperties);
};

// One stop shop for creating a theme with custom properties
const createMergedTheme = themeProperties => {
  return createTheme(mergeThemeProperties(themeProperties));
};
export { theTheme as default, baseThemeProperties, mergeThemeProperties, createMergedTheme, LinkBehavior };